<template>
  <div class="subtitle">
    <div class="title">
      {{ title }}
    </div>
    <div class="subtext" v-if="subtext">
      {{ subtext }}
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'title',
    'subtext'
  ]
}
</script>

<style scoped lang="sass">

.subtitle
  margin: 0 0 25px 0
  padding: 0

  .title
    font-family: 'Roboto Condensed', sans-serif
    color: #252525
    font-size: 24px
    margin: 0
    padding: 0
    font-weight: 700
    line-height: 1

  .subtext
    font-family: 'Roboto', sans-serif
    color: #6a6a6a
    font-size: 16px
    font-weight: 400
    margin: 0
    line-height: 1.3
    padding: 10px 0 0 0

</style>
